module.exports = __webpack_public_path__ + "images/home7.webp";